module.exports = __webpack_public_path__ + "img/PD1505009048397938688.374c8dc2.png";